import { Button, ButtonProps } from 'antd';
import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader';

export interface LoadingButtonProps extends ButtonProps {
  isLoading?: boolean;
}

export const LoadingButton: React.FC<LoadingButtonProps & React.RefAttributes<HTMLElement>> = (props) => {
  return (
    <Button {...props} disabled={props.isLoading || props.disabled}>
      {props.isLoading ? <ClipLoader size={24} /> : props.children}
    </Button>
  );
};

export default LoadingButton;
